export default "__VITE_ASSET__CmLE6IxX__"